import {Col, Form, Input, Row } from 'antd';
import React, { Fragment, useState } from 'react';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import CustomEmpty from '../../../../../../../components/custom-empty';
import EnhancedModal from '../../../../../../../components/enhanced-modal';
import FormList from '../../../../../../../components/form-list';
import ItemList from '../../../../../../../components/item-list';
import Selector from '../../../../../../../components/selector';
import { DataLanguageConsumer } from '../../../../../../../contexts/DataLanguage';
import { GUTTER_MD, MARGIN_MD, MODAL_WIDTH_LG, SPAN_ONE_THIRD, SPAN_TWO_THIRDS } from '../../../../../../../styles/constants';
import { getArtefactTripletFromString } from '../../../../../../../utils/sdmxJson';
import { getInitialCondition } from '../../../utils';
import CalculatedCondition from './CalculatedCondition';

const mapPropsToFields = ({value}) => ({
  componentValueText: Form.createFormField({value: (value.componentValue || "").length > 0 
        ? value.componentValue 
        : null}),
});

const CalculatedBlock = ({
    t,
    form,
    appLanguage,
    components,
    codelistCode,
    componentValueDefinition,
    value,
    componentCodelistCodesItemsPage,
    componentCodelistCodesItemsCount,
    fetchCodelistCodesItemsPage,
    onComponentValueDefinitionValueSet,

  }) => {  

    const codelistTriplet = codelistCode ? getArtefactTripletFromString(codelistCode) : null;

    const [isCodeSelectorVisible, setCodeSelectorVisible] = useState(false);

    const conditionsNumber = (value.conditions || []).length;

    const onComponentValueFromSelectorSet = (value) => {
      onComponentValueDefinitionValueSet(value);
      setCodeSelectorVisible(false);
    }
    
    return (
      <Fragment>
        {conditionsNumber > 0
        ? <Row gutter={GUTTER_MD} style={{ marginBottom: MARGIN_MD }} type="flex" align="middle">
            <Col span={SPAN_TWO_THIRDS}>
              <FormList
                  compact
                  notCollapsable
                  values={value.conditions}
                  Component={CalculatedCondition}
                  componentProps={
                    {
                      components:components,
                      appLanguage:appLanguage,
                      onComponentValueDefinitionValueSet:onComponentValueDefinitionValueSet,
                      blockIdx:value.idx,
                      componentCodelistCodesItemsPage:componentCodelistCodesItemsPage,
                      componentCodelistCodesItemsCount:componentCodelistCodesItemsCount,
                      fetchCodelistCodesItemsPage:fetchCodelistCodesItemsPage,
                    }
                  }
                  newItem={getInitialCondition(components[0].name, conditionsNumber)}
                  minItems={1}
                  addItemLabel={t('components.whereConditionsForm.block.addConditionButton')}
                  removeItemLabel={t('components.whereConditionsForm.block.removeButton')}
                  onChange={values => onComponentValueDefinitionValueSet({blockIdx: value.idx, conditions:values})}
              /> 
            </Col>
            <Col span={SPAN_ONE_THIRD} style={{ marginBottom: 54}}>
              <Row align="middle">
                <Col span={10} style={{'paddingLeft': 0,'paddingRight': 8}}>
                  {`${componentValueDefinition.cubeComponent.name}=`}
                </Col>
                <Col span={14} style={{'paddingLeft': 0,'paddingRight': 0}}>
                  {form.getFieldDecorator("componentValueText")(
                    (codelistCode || "").length > 0 ? 
                    (
                      <Selector
                        onSelect={() => setCodeSelectorVisible(true)}
                        onReset={() => onComponentValueDefinitionValueSet({blockIdx: value.idx,componentValue:{text:null}})} 
                      />
                    )
                    : (
                      
                      <Input 
                        title={form.getFieldValue("componentValueText")}
                        onChange={({target}) =>
                            onComponentValueDefinitionValueSet({blockIdx: value.idx,componentValue:{text:target.value}})} 
                      />
                    )            
                  )}
                </Col>
              </Row>            
            </Col> 
          </Row>      
        : <CustomEmpty/>
        }

        <EnhancedModal
          visible={isCodeSelectorVisible}
          onCancel={() => setCodeSelectorVisible(false)}
          title={t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.valueDefinitionForm.valueSelector.title')}
          width={MODAL_WIDTH_LG}        
          withDataLanguageSelector
        >
          <DataLanguageConsumer>   
            {dataLanguage => {
              const language = dataLanguage || appLanguage;
              return (
                <ItemList
                  data={componentCodelistCodesItemsPage || null}
                  rowCount={componentCodelistCodesItemsCount}
                  isPaginated
                  onRowClick={item => onComponentValueFromSelectorSet({blockIdx: value.idx,componentValue:{text:item.id}})}     
                  onChange={
                    ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) =>
                    fetchCodelistCodesItemsPage({
                        codelistTriplet,
                        language,
                        pageNum,
                        pageSize,
                        searchText,
                        filters,
                        sortCol,
                        sortByDesc
                      })
                  }
                />
              );
            }}     
          </DataLanguageConsumer>
        </EnhancedModal>

      </Fragment>
      
    );   
  };

export default compose(
  translate(),
  Form.create({mapPropsToFields})
)(CalculatedBlock);
